import React, { useState, useEffect } from 'react';
import api from '../api/axios';

const FloatingWidgets = () => {
  const [showScrollTop, setShowScrollTop] = useState(false);
  const [whatsappNumber, setWhatsappNumber] = useState('919449818329');
  const [phoneNumber, setPhoneNumber] = useState('9449 818 329');

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 250) {
        setShowScrollTop(true);
      } else {
        setShowScrollTop(false);
      }
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const res = await api.get('/api/settings');
        if (res.data) {
          const rawPhone = res.data.storePhone || res.data.phone || '9449 818 329';
          setPhoneNumber(rawPhone);
          // Clean non-digits
          const cleaned = rawPhone.replace(/\D/g, '');
          if (cleaned.length === 10) {
            setWhatsappNumber(`91${cleaned}`);
          } else if (cleaned.length > 10) {
            setWhatsappNumber(cleaned);
          }
        }
      } catch (err) {
        // Fallback to default
      }
    };
    fetchSettings();
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(
    'Hello Healthy Homes, I would like to know more about your products!'
  )}`;

  const cleanPhoneForTel = phoneNumber.replace(/[^\d+]/g, '');
  const telUrl = `tel:${cleanPhoneForTel}`;

  return (
    <>
      <style>{`
        /* Floating Phone Call Button */
        .floating-phone-btn {
          position: fixed;
          bottom: 90px;
          left: 24px;
          width: 54px;
          height: 54px;
          border-radius: 50%;
          background: linear-gradient(135deg, #2FA84F 0%, #1c7c34 100%);
          color: #ffffff !important;
          display: flex;
          align-items: center;
          justify-content: center;
          box-shadow: 0 6px 18px rgba(47, 168, 79, 0.42);
          z-index: 50;
          transition: transform 0.25s cubic-bezier(0.25, 1, 0.5, 1), box-shadow 0.25s cubic-bezier(0.25, 1, 0.5, 1);
          text-decoration: none;
          cursor: pointer;
        }

        .floating-phone-btn:hover {
          transform: scale(1.1) translateY(-3px);
          box-shadow: 0 10px 24px rgba(47, 168, 79, 0.55);
          color: #ffffff !important;
        }

        .floating-phone-pulse {
          position: absolute;
          inset: -4px;
          border-radius: 50%;
          border: 2px solid #2FA84F;
          animation: phonePulse 2s cubic-bezier(0.24, 0, 0.38, 1) infinite;
          pointer-events: none;
        }

        @keyframes phonePulse {
          0% {
            transform: scale(0.95);
            opacity: 0.8;
          }
          70% {
            transform: scale(1.35);
            opacity: 0;
          }
          100% {
            transform: scale(1.4);
            opacity: 0;
          }
        }

        /* Floating WhatsApp Button */
        .floating-whatsapp-btn {
          position: fixed;
          bottom: 24px;
          left: 24px;
          width: 54px;
          height: 54px;
          border-radius: 50%;
          background: linear-gradient(135deg, #25D366 0%, #128C7E 100%);
          color: #ffffff !important;
          display: flex;
          align-items: center;
          justify-content: center;
          box-shadow: 0 6px 18px rgba(37, 211, 102, 0.42);
          z-index: 50;
          transition: transform 0.25s cubic-bezier(0.25, 1, 0.5, 1), box-shadow 0.25s cubic-bezier(0.25, 1, 0.5, 1);
          text-decoration: none;
          cursor: pointer;
        }

        .floating-whatsapp-btn:hover {
          transform: scale(1.1) translateY(-3px);
          box-shadow: 0 10px 24px rgba(37, 211, 102, 0.55);
          color: #ffffff !important;
        }

        .floating-whatsapp-pulse {
          position: absolute;
          inset: -4px;
          border-radius: 50%;
          border: 2px solid #25D366;
          animation: waPulse 2s cubic-bezier(0.24, 0, 0.38, 1) infinite;
          pointer-events: none;
        }

        @keyframes waPulse {
          0% {
            transform: scale(0.95);
            opacity: 0.8;
          }
          70% {
            transform: scale(1.35);
            opacity: 0;
          }
          100% {
            transform: scale(1.4);
            opacity: 0;
          }
        }

        /* Floating Scroll to Top Button */
        .floating-scroll-top-btn {
          position: fixed;
          bottom: 24px;
          right: 24px;
          width: 48px;
          height: 48px;
          border-radius: 50%;
          background: linear-gradient(135deg, #16a34a 0%, #15803d 100%);
          color: #ffffff !important;
          border: 2px solid rgba(255, 255, 255, 0.8);
          display: flex;
          align-items: center;
          justify-content: center;
          box-shadow: 0 6px 16px rgba(22, 163, 74, 0.35);
          z-index: 49;
          cursor: pointer;
          transition: opacity 0.3s ease, transform 0.3s cubic-bezier(0.25, 1, 0.5, 1), box-shadow 0.25s ease;
        }

        .floating-scroll-top-btn:hover {
          transform: scale(1.1) translateY(-3px);
          box-shadow: 0 10px 22px rgba(22, 163, 74, 0.48);
          background: linear-gradient(135deg, #15803d 0%, #166534 100%);
        }

        @media (max-width: 576px) {
          .floating-phone-btn {
            bottom: 74px;
            left: 16px;
            width: 48px;
            height: 48px;
          }
          .floating-whatsapp-btn {
            bottom: 18px;
            left: 16px;
            width: 48px;
            height: 48px;
          }
          .floating-scroll-top-btn {
            bottom: 18px;
            right: 16px;
            width: 44px;
            height: 44px;
          }
        }
      `}</style>

      {/* Floating Phone Call Button */}
      <a
        href={telUrl}
        className="floating-phone-btn"
        title={`Call us: ${phoneNumber}`}
        aria-label={`Call us at ${phoneNumber}`}
      >
        <span className="floating-phone-pulse" />
        <i className="ph-fill ph-phone-call" style={{ fontSize: '24px' }} />
      </a>

      {/* Floating WhatsApp Button */}
      <a
        href={whatsappUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="floating-whatsapp-btn"
        title="Chat with us on WhatsApp"
        aria-label="WhatsApp Chat"
      >
        <span className="floating-whatsapp-pulse" />
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 448 512"
          width="26"
          height="26"
          fill="currentColor"
        >
          <path d="M380.9 97.1C339 55.1 283.2 32 223.9 32c-122.4 0-222 99.6-222 222 0 39.1 10.2 77.3 29.6 111L0 480l117.7-30.9c32.4 17.7 68.9 27 106.1 27h.1c122.3 0 224.1-99.6 224.1-222 0-59.3-25.2-115-67.1-157zm-157 341.6c-33.2 0-65.7-8.9-94-25.7l-6.7-4-69.8 18.3L72 359.2l-4.4-7c-18.5-29.4-28.2-63.3-28.2-98.2 0-101.7 82.8-184.5 184.6-184.5 49.3 0 95.6 19.2 130.4 54.1 34.8 34.9 56.2 81.2 56.1 130.5 0 101.8-84.9 184.6-186.6 184.6zm101.2-138.2c-5.5-2.8-32.8-16.2-37.9-18-5.1-1.9-8.8-2.8-12.5 2.8-3.7 5.6-14.3 18-17.6 21.8-3.2 3.7-6.5 4.2-12 1.4-32.6-16.3-54-29.1-75.5-66-5.7-9.8 5.7-9.1 16.3-30.3 1.8-3.7.9-6.9-.5-9.7-1.4-2.8-12.5-30.1-17.1-41.2-4.5-10.8-9.1-9.3-12.5-9.5-3.2-.2-6.9-.2-10.6-.2-3.7 0-9.7 1.4-14.8 6.9-5.1 5.6-19.4 19-19.4 46.3 0 27.3 19.9 53.7 22.6 57.4 2.8 3.7 39.1 59.7 94.8 83.8 35.2 15.2 49 16.5 66.6 13.9 10.7-1.6 32.8-13.4 37.4-26.4 4.6-13 4.6-24.1 3.2-26.4-1.3-2.5-5-3.9-10.5-6.6z" />
        </svg>
      </a>

      {/* Floating Scroll to Top Button */}
      <button
        type="button"
        onClick={scrollToTop}
        className="floating-scroll-top-btn"
        style={{
          opacity: showScrollTop ? 1 : 0,
          pointerEvents: showScrollTop ? 'auto' : 'none',
          transform: showScrollTop ? 'translateY(0)' : 'translateY(16px)'
        }}
        title="Scroll to Top"
        aria-label="Scroll to Top"
      >
        <i className="ph-bold ph-arrow-up" style={{ fontSize: '20px' }} />
      </button>
    </>
  );
};

export default FloatingWidgets;
